var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"logBox",staticClass:"log-box"},_vm._l((_vm.logs),function(log,index){return _c('div',{key:index,staticClass:"log-line",class:{ success: log.isSuccess, fail: !log.isSuccess }},[_vm._v(" "+_vm._s(_vm.buildMessage(log))+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }